import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useCreateSkillLevel, useUpdateSkillLevel } from "../../api/skillLevels";
import { useToast } from "../../components/ToastProvider";
import { SkillLevel } from "../../types/dtos";

export function SkillLevelModal({
  show,
  editing,
  onClose,
}: {
  show: boolean;
  editing: SkillLevel | null;
  onClose: () => void;
}) {
  const [name, setName] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");
  const [error, setError] = useState<string | null>(null);
  const create = useCreateSkillLevel();
  const update = useUpdateSkillLevel();
  const toast = useToast();

  useEffect(() => {
    if (show) {
      setName(editing?.name ?? "");
      setHourlyRate(editing ? String(editing.hourlyRate) : "");
      setError(null);
    }
  }, [show, editing]);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return setError("Informe o nome do nível.");
    const rate = Number(hourlyRate.replace(",", "."));
    if (!rate || rate <= 0) return setError("Informe um valor/hora válido.");
    try {
      if (editing) {
        await update.mutateAsync({ id: editing.id, input: { name, hourlyRate: rate } });
        toast("Nível atualizado.");
      } else {
        await create.mutateAsync({ name, hourlyRate: rate });
        toast("Nível cadastrado.");
      }
      onClose();
    } catch {
      setError("Não foi possível salvar — já existe um nível com esse nome?");
    }
  }

  return (
    <Modal backdrop="static" keyboard={false} show={show} onHide={onClose} centered className="nt-dialog">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>
            {editing ? "Editar nível" : "Novo nível de habilidade"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <div>
            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: 700 }}>
              Nome
            </label>
            <input
              className="form-control"
              autoFocus
              placeholder="Ex.: Júnior, Pleno, Sênior…"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div>
            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: 700 }}>
              Valor por hora (R$)
            </label>
            <input className="form-control" placeholder="0,00" value={hourlyRate} onChange={(e) => setHourlyRate(e.target.value)} />
          </div>
          {error && (
            <div className="text-danger" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={create.isPending || update.isPending}>
            Salvar
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
